import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface Inputs {
  title: string;
  subcategoryId: string;
  contentGroupId: string;
  date?: Date;
  startsAt?: string;
  endsAt?: string;
  hideDate?: boolean;
}

interface Props {
  noteId?: string;
	onSuccess?: (note, variables) => void;
  onError?: (res: AxiosError) => void;
}

export const useSaveNote = ({
  noteId,
	onSuccess,
  onError
}: Props) => {
  const queryClient = useQueryClient();
	const {
		mutate: onSaveNote,
    variables,
    ...rest
	} = useMutation({
		mutationFn: async ({ onlySave, ...data }: Inputs) => {
      if (noteId) 
        return axios.patch(`/notes/${noteId}`, data);
      return axios.post('/notes', data);
		},
		onSuccess: ({ data: { note } }) => {
      if (noteId)
        queryClient.invalidateQueries({ queryKey: ['note', noteId] });
      if (onSuccess)
        onSuccess(note, variables);
    },
    onError
	});

	return { onSaveNote, variables, ...rest };
};
